module.exports = __webpack_public_path__ + "static/media/delete_icon_image.ae425838.svg";